import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useCasteContext } from "./useCasteContext";
import API_URL from '../../api/APIUrl';

const CasteRow = ({id,title,religion}) => {
    const {dispatch} = useCasteContext();
    const {adminuser} = useAuthContext();

    const handleClick = async () =>{

        if(!adminuser) {
            return;
        }

        const response = await fetch(API_URL.DELETE_SINGLE_CASTE + id,{
            method:'DELETE',
            headers:{
                'Authorization': `Bearer ${adminuser.token}` 
            }
        });
        const json = await response.json();
        console.log(json);
        if(response.ok){
            dispatch({type:'DELETE_CASTE',payload:json});
        }
    }
    
    return (
        <tr key={id}>
            <th scope="row">{id}</th>
            <td>{title}</td>
            <td>{religion}</td>
            <td><span onClick={handleClick}>Delete</span></td>
        </tr>
    )
}

export default CasteRow;